import axios from 'axios';

export const processPdbId = async (apitoken, pdbId) => {
    try {
        // Prima chiamata: Attivazione del servizio DOWNLOAD_PDB
        const response = await axios.post(
            'https://cleanpdb.softmining.it/ws.php',
            {
                pdbId: pdbId,
                IDD: apitoken._id,
                Token: '000111',
                serviceName: 'ENQUEUE_DOWNLOADPDB_REQUEST',
            }
        );

        console.log(`Enqueue for PDB ID: ${pdbId}`);
        console.log(response);

        let completed = false;
        while (!completed) { 
            const statusResult = await checkDownloadPDBStatus(apitoken, pdbId);

            if (statusResult.data.output === "REQUEST COMPLETED")
                completed = true;

            if (statusResult.data.output === "ITEM NOT FOUND") {
                console.log(pdbId);
                console.log(apitoken);
            }
               

            console.log(`Request Status for PDB ID: ${pdbId}`);
            console.log(statusResult);

            await new Promise(resolve => setTimeout(resolve, 2000));
        }

        const responseFile = await axios.post(
            'https://cleanpdb.softmining.it/ws.php',
            {
                pdbId: pdbId,
                IDD: apitoken._id,
                Token: '000111',
                serviceName: 'DOWNLOADPDB_GET_OUTPUT',
            }
        );

        console.log('Response from DOWNLOADPDB_GET_OUTPUT:', responseFile);

        if (!responseFile.data.output) {
            throw new Error("PDB File not exists.");
        }

        const pdbContent = responseFile.data.output;
        const fileBlob = new Blob([pdbContent], { type: 'chemical/x-pdb' });
        const fileUrl = URL.createObjectURL(fileBlob);

        return { name: `DOWNLOAD_${pdbId}.pdb`, url: fileUrl };
    } catch (error) {
        throw new Error(`Errore nel processo PDB ID ${pdbId}: ${error.message}`);
    }
};

export const processFile = async (file, apitoken) => {
    const fileText = await file.text(); // Legge il contenuto del file
    const pdbIds = fileText.split('\n').map((line) => line.trim()).filter(Boolean);
    const results = [];
    for (const pdb of pdbIds) {
        try {
            const result = await processPdbId(apitoken, pdb);
            results.push(result);
        } catch (err) {
            console.error(err);
        }
    }
    return results;
};


export const checkDownloadPDBStatus = async(apitoken, pdbId) => {
    try {
        const response = await axios.post(
            'https://cleanpdb.softmining.it/ws.php',
            {
                pdbId: pdbId,
                IDD: apitoken._id,
                Token: '000111',
                serviceName: 'DOWNLOADPDB_REQUEST_STATUS',
            }
        );
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};
